import React from "react";
import CycleRenderer from "./CycleRenderer";
import PropTypes from "prop-types";
import {get, isEqual} from "lodash";
import {compose} from "redux";
import {connect} from "react-redux";
import {getEventDate} from "./utils";

function mapStateToProps(state) {
    return {
        noPregnancyReason: state.dictionary.noPreganancy,
        lang: state.language.lang.lang,
    };
}

class NoPregnancyRenderer extends React.Component {
    state = {
        hoveredID: "",
    };

    onMouseEnter = (event) => {
        const cell = get(event, "currentTarget");
        if (cell) {
            const EvID = cell.id.split(" ")[0];
            this.setState({
                hoveredID: EvID,
            });
        }
    };

    onMouseLeave = () => {
        this.setState({
            hoveredID: "",
        });
    };

    getReason = (noPregnancy) => {
        const {noPregnancyReason} = this.props;
        const reason = noPregnancyReason.WData.find(
            (item) => item.ID === get(noPregnancy, "event.EvData.Reason")
        );
        return get(reason, "Value", "");
    };
    render() {
        const {
            cycle: {noPregnancy, key},
            expanded: {rows},
            isAdvanced,
            deletionMode,
            onDeleteClick,
            onDoubleEventClick,
            isInterrupted,
            printing,
        } = this.props;
        const {hoveredID} = this.state;
        const lastNoPregnancy = noPregnancy[noPregnancy.length - 1];
        let rowValue = rows.find((o) => o === key);
        const nP = lastNoPregnancy;
        if (!nP) {
            return (
                <>
                    {isAdvanced && (
                        <CycleRenderer
                            className="print-display-none"
                            isInterrupted={isInterrupted}
                        />
                    )}
                    <CycleRenderer
                        className="print-display-none last-cell"
                        isInterrupted={isInterrupted}
                    />
                </>
            );
        }
        const operators = noPregnancy[0].operators;
        return (
            <>
                {isAdvanced && (
                    <CycleRenderer className="print-display-none">
                        {isAdvanced && (isEqual(key, rowValue) || printing) ? (
                            noPregnancy.map((nP, index) => (
                                <div
                                    className={`cell-wrapper ${hoveredID === nP.event.EvID ? "error" : "success"}`}
                                    id={`${nP.event.EvID} EvTime`}
                                    onDoubleClick={onDoubleEventClick}
                                    onMouseEnter={
                                        deletionMode
                                            ? this.onMouseEnter
                                            : undefined
                                    }
                                    onMouseLeave={
                                        deletionMode
                                            ? this.onMouseLeave
                                            : undefined
                                    }
                                    onClick={
                                        deletionMode ? onDeleteClick : undefined
                                    }>
                                    {getEventDate(nP)}
                                </div>
                            ))
                        ) : (
                            <div
                                className={`cell-wrapper ${hoveredID === lastNoPregnancy.event.EvID ? "error" : "success"}`}
                                id={`${lastNoPregnancy.event.EvID} EvTime`}
                                onDoubleClick={onDoubleEventClick}
                                onMouseEnter={
                                    deletionMode ? this.onMouseEnter : undefined
                                }
                                onMouseLeave={
                                    deletionMode ? this.onMouseLeave : undefined
                                }
                                onClick={
                                    deletionMode ? onDeleteClick : undefined
                                }>
                                {getEventDate(lastNoPregnancy)}
                            </div>
                        )}
                    </CycleRenderer>
                )}
                <CycleRenderer
                    className="print-display-none last-cell"
                    isAdvanced={isAdvanced}
                    operators={operators}
                    deletionMode={deletionMode}>
                    {isAdvanced && (isEqual(key, rowValue) || printing) ? (
                        noPregnancy.map((nP, index) => (
                            <div
                                className={`cell-wrapper ${hoveredID === nP.event.EvID ? "error" : "success"}`}
                                id={`${nP.event.EvID} EvData.Reason`}
                                onDoubleClick={onDoubleEventClick}
                                onClick={
                                    deletionMode ? onDeleteClick : undefined
                                }
                                onMouseEnter={
                                    deletionMode ? this.onMouseEnter : undefined
                                }
                                onMouseLeave={
                                    deletionMode ? this.onMouseLeave : undefined
                                }>
                                {this.getReason(nP)}
                            </div>
                        ))
                    ) : (
                        <div
                            className={`cell-wrapper ${hoveredID === lastNoPregnancy.event.EvID ? "error" : "success"}`}
                            id={`${lastNoPregnancy.event.EvID} EvData.Reason`}
                            onDoubleClick={onDoubleEventClick}
                            onClick={deletionMode ? onDeleteClick : undefined}
                            onMouseEnter={
                                deletionMode ? this.onMouseEnter : undefined
                            }
                            onMouseLeave={
                                deletionMode ? this.onMouseLeave : undefined
                            }>
                            {this.getReason(lastNoPregnancy)}
                        </div>
                    )}
                </CycleRenderer>
            </>
        );
    }
}

NoPregnancyRenderer.propTypes = {
    cycle: PropTypes.shape({
        noPregnancy: PropTypes.array.isRequired,
    }).isRequired,
};

export default compose(connect(mapStateToProps))(NoPregnancyRenderer);
